import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { useEffect } from "react";
import { toast } from "../lib/toast";
import { ApiErrorType } from "../types";

export default function useError(
  isError: boolean,
  error: FetchBaseQueryError | SerializedError | undefined,
  message: string
) {
  useEffect(() => {
    if (isError && error) {
      const err = error as ApiErrorType;
      const msg = err.data?.message;
      const rawData = (err as any)?.data;
      const normalizedMsg = String(
        msg ||
          rawData?.error ||
          rawData?.detail ||
          (typeof rawData === "string" ? rawData : "")
      ).toLowerCase();
      const statusCode = Number(
        err?.status || err?.data?.statusCode || (err as any)?.originalStatus || 0
      );
      const isAuthError =
        statusCode === 401 ||
        statusCode === 403 ||
        normalizedMsg.includes("unauthorized") ||
        normalizedMsg.includes("forbidden");
      const isLocalHost =
        typeof window !== "undefined" &&
        (window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1");

      // In local integration runs, many optional services may still reject auth
      // while core pages work. Avoid noisy auth toasts for those transient calls.
      if (isLocalHost && isAuthError) return;

      toast("error", msg && typeof msg === "string" ? msg : message);
    }
  }, [error, isError, message]);

  return undefined;
}
